/// O "F5" do aplicativo.
///
/// Instalado, o QSMS abre numa janela sem barra do navegador, e ninguém sabe que o
/// F5 existe — no celular, nem existe. Mas recarregar de qualquer jeito tem dois
/// riscos que o botão resolve:
///
/// 1. **O que está sendo digitado.** A gravação espera uma pausa de 600 ms; recarregar
///    antes disso perderia a última frase. Quem tem algo pendente se registra aqui, e
///    é gravado antes.
/// 2. **A versão nova.** Num app instalado, a versão nova baixada fica esperando todas
///    as janelas fecharem, e um recarregar comum continua na velha. Aqui ela é ativada
///    antes, e o recarregar já abre a nova.

const antes = new Set<() => Promise<void>>()

/// Registra algo a gravar antes de recarregar. Devolve a função que desfaz.
export function antesDeRecarregar(gravar: () => Promise<void>): () => void {
  antes.add(gravar)
  return () => {
    antes.delete(gravar)
  }
}

function esperar(ms: number) {
  return new Promise<void>((ok) => setTimeout(ok, ms))
}

async function ativarVersaoNova(): Promise<void> {
  const registro = await navigator.serviceWorker?.getRegistration()
  if (!registro) return
  // Sem rede, a checagem falha e recarrega com o que já está no aparelho.
  await registro.update().catch(() => undefined)

  // A checagem pode ter achado uma versão que ainda está instalando.
  const instalando = registro.installing
  if (instalando) {
    await Promise.race([
      new Promise<void>((ok) =>
        instalando.addEventListener('statechange', () => {
          if (instalando.state === 'installed' || instalando.state === 'redundant') ok()
        }),
      ),
      esperar(5000),
    ])
  }

  const esperando = registro.waiting
  if (!esperando) return
  await Promise.race([
    new Promise<void>((ok) => {
      navigator.serviceWorker.addEventListener('controllerchange', () => ok(), { once: true })
      esperando.postMessage({ type: 'SKIP_WAITING' })
    }),
    esperar(3000),
  ])
}

export async function recarregarApp(): Promise<void> {
  await Promise.allSettled([...antes].map((gravar) => gravar()))
  try {
    await ativarVersaoNova()
  } catch {
    // Service worker indisponível (navegação privada, navegador antigo): recarrega
    // do mesmo jeito.
  }
  window.location.reload()
}
